import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { proposalStatus } from "../placeholder";

export default function ({ title, className }) {
  const [status, setStatus] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    setStatus(proposalStatus);
  }, []);

  return (
    <div
      className={classNames("statusblock block-view", {
        [className]: !!className,
      })}
    >
      {title && <h3 className="statusblock__title">{title}</h3>}
      <ul className="statusblock__list">
        {status.map((item) => (
          <li className="statusblock-item" key={item.id}>
            <label
              className="statusblock-item__label"
              htmlFor={`status-` + item.name}
            >
              <input
                className="statusblock-item__input"
                type="radio"
                name="status"
                value={item.name}
                id={`status-` + item.name}
                checked={item.name === active}
                onChange={(e) => setActive(e.target.value)}
              />
              <div
                className={classNames("statusblock-item__status", {
                  ok: item.name === active,
                })}
              ></div>
              <div className="statusblock-item__content">
                <div className="statusblock-item__name">{item.name}</div>
                <div className="statusblock-item__date">{item.date}</div>
              </div>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
